<template lang="pug">
div.row.flex-align-end.mb-32
  div.flex.flex-align-end.flex-grow
    div.col-4(v-if="creative.type != 'None'")
      h4.mb-2 {{creative.type_string}}
      div.small-text Creative type
    div.col-4
      h4.mb-2(v-if='creative.device === 3')
        span(v-if='creative.quantum_live_sizes != null') {{creative.quantum_live_sizes.join(", ")}}
        span(v-else) {{creative.width}} x {{creative.height}}
      h4.mb-2(v-else) {{creative.width}} x {{creative.height}}
      div.small-text Size
    div.col-4
      h4.mb-2 {{creative.template != null ? creative.template.name : "Custom"}}
      div.small-text Layout
    div.col(v-if="creative.live_dsp != 'None' && creative.live_dsp_title != null")
      h4.mb-2 {{creative.live_dsp_title}}
      div.small-text Platform
</template>

<script>
export default {
  name: 'SummaryCardHeader',

  props: {
    creative: Object
  }
};
</script>
